import React from 'react';
import { ThemedText } from '../../../components';
import { parseCoordinates } from '../parsers';

export default function CoordinatesValue({ value, emptyValue = '—', theme }) {
  const coords = parseCoordinates(value);
  if (!coords) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }
  return <ThemedText>{coords.latitude.toFixed(6)}, {coords.longitude.toFixed(6)}</ThemedText>;
}
